module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sidebar'), _vm._v(" "), _c('topbar'), _vm._v(" "), _c('edit'), _vm._v(" "), _c('modal-code'), _vm._v(" "), _c('modal-delete-step'), _vm._v(" "), _c('modal-duplicate-step')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5e5420e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Edit.vue
 ** module id = 840
 ** module chunks = 1
 **/